import React, { useEffect, useState } from "react";
import DashboardLayout from "./DashboardLayout";
import axios from "axios";

const DashboardBilling = () => {
  const [plan, setPlan] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch current plan and payment history from backend
    const fetchData = async () => {
      try {
        const planRes = await axios.get("/api/get_subscription.php");
        setPlan(planRes.data);
        const historyRes = await axios.get("/api/get_payment_history.php");
        setHistory(historyRes.data);
      } catch (err) {
        // handle error
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleUpgrade = async (newPlan) => {
    // Redirect to payment gateway or show modal
    window.location.href = `/payment/checkout?plan=${newPlan}`;
  };

  if (loading) return <DashboardLayout><div>Loading...</div></DashboardLayout>;

  return (
    <DashboardLayout>
      <div style={{ maxWidth: 700, margin: "0 auto" }}>
        <h2>Subscription & Billing</h2>
        <div className="card mb-4">
          <div className="card-body">
            <h4>Current Plan: {plan?.name || "N/A"}</h4>
            <p>Status: {plan?.status}</p>
            <p>Renewal Date: {plan?.renewal_date}</p>
            <p>Features: {plan?.features?.join(", ")}</p>
            <div>
              <button className="btn btn-success" onClick={() => handleUpgrade("pro")}>Upgrade to Pro</button>
              <button className="btn btn-warning ms-2" onClick={() => handleUpgrade("free")}>Downgrade to Free</button>
            </div>
          </div>
        </div>
        <h4>Payment History</h4>
        <table className="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Plan</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Invoice</th>
            </tr>
          </thead>
          <tbody>
            {history.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.plan}</td>
                <td>{item.amount}</td>
                <td>{item.status}</td>
                <td>
                  <a href={item.invoice_url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary">
                    Download PDF
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default DashboardBilling; 